import React from 'react';
import PropTypes from 'prop-types';

const SectionContext = React.createContext({});

class SectionContextProvider extends React.Component {
    state = {};

    static getDerivedStateFromProps(props, state) {
        const getStateFromProps = ({fullUrlPath, layout, pointerCategoryID, title, subtype, carouselType}) => {
            return {fullUrlPath, layout, pointerCategoryID, title, subtype, carouselType};
        };

        return {...state, context: getStateFromProps(props.value)};
    }

    render() {
        return <SectionContext.Provider value={this.state.context}>{this.props.children}</SectionContext.Provider>;
    }
}

SectionContextProvider.propTypes = {
    value: PropTypes.shape({
        fullUrlPath: PropTypes.string,
        layout: PropTypes.string,
        pointerCategoryID: PropTypes.number,
        title: PropTypes.string,
        subtype: PropTypes.string,
        carouselType: PropTypes.string
    }).isRequired
};

const withSectionContext = (WrappedComponent) => ({context, ...props}) => (
    <SectionContext.Consumer>{(section) => <WrappedComponent context={{...context, section}} {...props} />}</SectionContext.Consumer>
);

export {withSectionContext, SectionContext};

export default SectionContextProvider;
